export enum GradeSelectorSortMode {
    OrderBySubModelGradePrice, // Default: Respect submodel order, sort by grade price within submodel
    OrderByGradePrice, // Sort by grade price, across all submodels
    OrderBySubModelGradeSortOrder, // Respect submodel order, then by grade sortIndex
    OrderByGradeSortOrder, // Sort by grade sortIndex, across all submodels
}

export type GradeSelectorSortModeType = GradeSelectorSortMode;
